module.exports = __webpack_public_path__ + "img/scroll-top.309d98be.svg";